import React from 'react';
import CampaignCards from '../CampaignCards';

export type ReferralTabsTypes = 'Website' | 'Telegram' | 'Game';
export type IReferralData = {
  game: boolean;
  telegram: boolean;
  website: boolean;
};

const AchievementsContent = () => (
  <div className='bg-[#3C3B3B] bg-opacity-40 rounded-[10px] p-2' id='test-2'>
    <CampaignCards />
  </div>
);

export default AchievementsContent;
